import React from "react";
import objectUtils from "utils/object";

const getSurchargeLabel = props => {
  const payTypeSelected = objectUtils.get(props, "payTypeSelected", undefined);
  if (payTypeSelected === "C" && !!props.campaignRateCC && props.total > 0) {
    const isFlatRate = props.campaignRateCC.discountType === "F";
    return !!isFlatRate
      ? ` (+ ${props.campaignRateCC.amount} SURCHARGE)`
      : ` (% ${props.campaignRateCC.amount} SURCHARGE)`;
  }
  return "";
};

const getButtonText = props => {
  const buttonText = !!props.buttonText ? props.buttonText : "Place Order";
  return <b>{`${buttonText}${getSurchargeLabel(props)}`}</b>;
};

const getStyle = disabled => {
  if (disabled) {
    return {
      background: "var(--lt-color-muted)",
      color: "var(--lt-color-muted-foreground)",
      border: "1px solid var(--lt-color-border)",
      cursor: "not-allowed"
    };
  }
  return {
    cursor: "pointer",
    minWidth: "100px"
  };
};

const PaymentButton = props => {

  const containerClassName = `payment-buttons ${props.containerClassName ||""}`; 
  const disabled = (!props.payTypeSelected || !!props.disabled) || (props.payTypeSelected === "C" && props.total === 0);

  return (
    <div className={containerClassName}>
      <a>
        <button
          disabled={disabled}
          style={getStyle(disabled)}
          className="btn orange-bold"
          onClick={() => props.handlePlaceOrder()}
        >
          {getButtonText(props)}
        </button>
      </a>
    </div>
  );
};

export default PaymentButton;



// WEBPACK FOOTER //
// ./src/containers/Menu/Cart/PaymentButton/index.js